const envvars = process.env;

export const environmentVariables = {
  apiUrl: envvars.REACT_APP_API_BACKEND,
};
